






























































































import store from '../store'
import dayjs from 'dayjs'

export default {
  props: {
    data1: {
      required: false
    },
    data2: {
      required: false
    },
    data3: {
      required: false
    },
    name: {
      type: String,
      default: 'Scenario 1',
      required: true
    },
    date: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
      required: true
    }
  },

  data (this:any) {
    return {
      selectedScenario: null,
      tName: this.name,
      tDate: this.date,
      saved: {
        status: false,
        timeout: 1500,
        message: 'Scenario saved.'
      }
    }
  },

  computed: {
    loadItems(this:any) {
      return store.state.scenarios.filter((s: any) => s.type === this.$route.name).map((s:any) => {
        return {
          type: this.$route.name,
          name: s.name,
          date: s.date
        }
      })
    }
  },

  methods: {
    // Save current scenario
    saveScenario(this:any) {
      let index = -1
      if (this.selectedScenario) {
        for (let i = 0; i < store.state.scenarios.length; i++) {
          if (this.selectedScenario.name === this.tName) {
            if (
              this.selectedScenario.type === store.state.scenarios[i].type &&
              this.selectedScenario.name === store.state.scenarios[i].name &&
              this.selectedScenario.date === store.state.scenarios[i].date
            ) {
              index = i
            }
          }
        }
      }

      let d1 = typeof this.data1 === 'object' ? this.cleanSource(this.data1) : this.data1
      let d2 = typeof this.data2 === 'object' ? this.cleanSource(this.data2) : this.data2
      let d3 = typeof this.data3 === 'object' ? this.cleanSource(this.data3) : this.data3

      // Update Existing
      if (index > -1) {
        let updatedScenarios = store.state.scenarios
        updatedScenarios[index].date = this.tDate
        updatedScenarios[index].data1 = d1
        updatedScenarios[index].data2 = d2
        updatedScenarios[index].data3 = d3
        store.dispatch('updateScenario', updatedScenarios)
        this.saved.message = 'Scenario ' + updatedScenarios[index].name + ' updated.'
      // Add New
      } else {
        let newScenario = {
          type: this.$route.name,
          name: this.tName,
          date: this.tDate,
          data1: d1,
          data2: d2,
          data3: d3
        }
        this.$store.dispatch('addScenario', newScenario)
        this.selectedScenario = store.state.scenarios[store.state.scenarios.length - 1]
        this.saved.message = 'Scenario ' + this.tName + ' saved.'
      }

      console.log('Scenarios', store.state.scenarios)

      this.saved.status = true
    },

    // Load selected scenario
    loadScenario(this:any, e:any) {
      let item = store.state.scenarios.filter((s:any) => (
        e.name === s.name && e.date === s.date
      ))[0]
      this.tName = item.name
      this.tDate = dayjs(item.date).format('YYYY-MM-DD')
      this.$emit('loadScenario', item)
    },

    // Delete scenario
    async deleteScenario(this:any, item:any) {
      if (await this.$root.$confirm.open(
        'Delete Scenario',
        'Are you sure you want to delete this scenario: ' + item.name,
        {
          color: 'red',
          cta: 'Delete'
        }
      )) {
        // Filter out scenario with matching name and type
        let updatedScenarios = store.state.scenarios.filter((s:any) => (
          (s.name !== item.name && s.type === item.type) || s.type !== item.type
        ))
        store.dispatch('updateScenario', updatedScenarios)
      }
    },

    // Remove reactivity from data source
    cleanSource<T>(source: T): T {
      return (JSON.parse(JSON.stringify(source)) as any) as T;
    }
  },

  store
}
